<template>
  <PageView v-if="page_module" :page-reference="PAGE_REFERENCES.CUSTOMER_JOURNEYS" :current-object-type="default_object_type_obj">
    <template #body>
      <LayoutContainer
        key="customer_journeys"
        v-model:current-template="current_template"
        :set-edit-mode="setEditMode"
        :edit-mode-active="edit_mode_active"
        class="mt-0"
        :page-reference="PAGE_REFERENCES.CUSTOMER_JOURNEYS" />
    </template>
  </PageView>
</template>

<script>
import LayoutContainer from "@/components/shared/pages/LayoutContainer.vue"
import PageView from "@/components/shared/pages/PageView.vue"
import { PAGE_REFERENCES, PAGE_REFERENCES_MODULES } from "@/store/constants/references"
export default {
  components: {
    LayoutContainer,
    PageView
  },
  inject: ["getModule"],
  beforeRouteLeave() {
    // called when the route that renders this component is about to be navigated away from.
    if (this?.edit_mode_active) {
      const answer = window.confirm(this.$t("You have unsaved changes, layout will be reverted if you don't save"))
      if (!answer) {
        return false
      } else {
        this.edit_mode_active = false
      }
    }
  },
  data() {
    return {
      PAGE_REFERENCES,
      page_module: null,
      edit_mode_active: false,
      current_template: null,
      default_object_type_obj: { type: "default" }
    }
  },
  created() {
    this.getPageModule()
  },
  methods: {
    getPageModule() {
      this.page_module = this.getModule(PAGE_REFERENCES_MODULES[PAGE_REFERENCES.CUSTOMER_JOURNEYS])
      if (!this.page_module) {
        setTimeout(() => {
          this.getPageModule()
        }, 500)
      }
    },
    setEditMode(value) {
      this.edit_mode_active = value
    }
  }
}
</script>
